import { apiClient, unwrapApi } from './http';

/**
 * Expenses API — /expenses/*
 */
export async function getExpenses(params = {}) {
  const { data } = await apiClient.get('/expenses', { params });
  return unwrapApi(data);
}

export async function getExpense(id) {
  const { data } = await apiClient.get(`/expenses/${id}`);
  return unwrapApi(data);
}

export async function createExpense(formData) {
  const { data } = await apiClient.post('/expenses', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return unwrapApi(data);
}

export async function updateExpense(id, formData) {
  const { data } = await apiClient.put(`/expenses/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return unwrapApi(data);
}

export async function deleteExpense(id) {
  const { data } = await apiClient.delete(`/expenses/${id}`);
  return unwrapApi(data);
}

export async function getExpenseStatsOverview(params = {}) {
  const { data } = await apiClient.get('/expenses/stats/overview', { params });
  return unwrapApi(data);
}

const expensesService = {
  getExpenses,
  getExpense,
  createExpense,
  updateExpense,
  deleteExpense,
  getExpenseStatsOverview,
};

export default expensesService;
